"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Heading = _interopRequireDefault(require("../Heading"));

var _StarRating = _interopRequireDefault(require("../StarRating"));

var _propTypes2 = require("../../utils/propTypes");

var _Box = _interopRequireDefault(require("../Box"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Text = _interopRequireDefault(require("../Text"));

var _Tags = _interopRequireDefault(require("../Tags"));

var _Divider = _interopRequireDefault(require("../Divider"));

var _Hide = _interopRequireDefault(require("../Hide"));

var ArticleCard = function ArticleCard(props) {
  var StartRatingComponent = props.StarRatingComponent || _StarRating["default"];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    borderRadius: "10px",
    backgroundColor: "white",
    id: props.id
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    flexDirection: ['column-reverse', null, 'row']
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    flex: "1",
    p: 6,
    pb: 0
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    flexDirection: "column",
    flex: "1 0"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "normal"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    fontWeight: "bold",
    fontSize: "xs",
    textTransform: "uppercase"
  }, props.badge), /*#__PURE__*/_react["default"].createElement(_Heading["default"].h2, {
    fontSize: "xl",
    fontWeight: "normal"
  }, props.title), (props.starRatingProps || props.tags) && /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: "center",
    flexDirection: "row",
    mb: 6
  }, props.starRatingProps && /*#__PURE__*/_react["default"].createElement(StartRatingComponent, props.starRatingProps), props.tags && /*#__PURE__*/_react["default"].createElement(_Tags["default"], {
    ml: props.starRatingProps ? 2 : 0
  }, props.tags.map(function (tag, key) {
    return /*#__PURE__*/_react["default"].createElement(_Tags["default"].Tag, {
      key: key
    }, tag);
  }))), props.description && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    fontSize: "md",
    mb: 6
  }, props.description), props.bodyComponent), props.footerCallToAction && /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    flexDirection: 'column',
    mt: [5, null, 'auto']
  }, /*#__PURE__*/_react["default"].createElement(_Hide["default"], {
    md: true,
    lg: true
  }, /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    width: "100%"
  })), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mt: [5, null, 3]
  }, props.footerCallToAction)))), props.imageComponent), props.footerComponent && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    p: 6
  }, props.footerComponent)), props.annotation);
};

ArticleCard.propTypes = {
  title: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string,
  description: _propTypes["default"].string,
  badge: _propTypes["default"].string.isRequired,
  starRatingProps: _propTypes["default"].shape(_propTypes2.StarRatingProps),
  tags: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired),
  annotation: _propTypes["default"].node,
  footerCallToAction: _propTypes["default"].node,
  footerComponent: _propTypes["default"].node,
  imageComponent: _propTypes["default"].node,
  bodyComponent: _propTypes["default"].node,
  StarRatingComponent: _propTypes["default"].elementType
};
var _default = ArticleCard;
exports["default"] = _default;